export type OutputType = {
    field: string;
    value: string;
    type: string;
    arrayStar: {color: string}[];
};

export function transformDataFormItem(input: string): OutputType[] {
    const parsedData = JSON.parse(input)

    return Object.entries(parsedData).map(([key, value]) => {
        const [field_0, field_1] = key.split('//').map(part => part.trim())

        const type = ['import_file', 'signature', 'satisfaction'].includes(field_0) ? field_0 : ''

        return {
            field: field_1 || key,
            value: value as string,
            type: type,
            arrayStar: [],
        }
    })
}